import Vue from 'vue';
import { ir } from './check_domain_ir';
import App from './App.vue';
import router from './router';
import store from '@/core/services/store';
import 'material-design-icons/iconfont/material-icons.css';
// Global 3rd party plugins
import 'popper.js';
import 'tooltip.js';
import PerfectScrollbar from 'perfect-scrollbar';
import DataTable from 'laravel-vue-datatable';
import ClipboardJS from 'clipboard';
// Vue 3rd party plugins
import i18n from '@/core/plugins/vue-i18n';
import vuetify from '@/core/plugins/vuetify';
import '@/core/plugins/portal-vue';
import '@/core/plugins/bootstrap-vue';
import '@/core/plugins/perfect-scrollbar';
import '@/core/plugins/highlight-js';
import '@/core/plugins/inline-svg';
import '@/core/plugins/apexcharts';
import '@/core/plugins/treeselect';
import '@/core/plugins/metronic';
import '@mdi/font/css/materialdesignicons.css';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

import { LOGOUT } from '@/core/services/store/auth.module';

//custom
import './custom';
import moment from 'moment-jalaali';
import { mapState } from 'vuex';
import axios from 'axios';
import VueToast from 'vue-toast-notification';
import TerminalTitleRibbon from '@/core/plugins/TitleRibbon/install';
import CustomPopup from '@/core/plugins/TitleRibbon/plugins/popup/customPopup';
import CustomTabs from '@/core/plugins/TitleRibbon/plugins/customTabs/index.vue';
import VueTable from '@/core/plugins/TitleRibbon/plugins/vueTable';
import {
  destroyToken,
  getToken,
  saveToken,
} from '@/core/plugins/TitleRibbon/assets/js/jwt.service';
import mobileTable from './core/plugins/mobileTable/src/install';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueTelInput);

export const pusher = Pusher;

export const echo = new Echo({
  wsHost: process.env.VUE_APP_SOCKET,
  broadcaster: 'pusher',
  key: process.env.VUE_APP_KEY,
  cluster: 'mt1',
  forceTLS: true,
});

window.Token = localStorage.getItem('id_token');

Vue.use(mobileTable);

Vue.use(VueToast, { position: 'top' });
Vue.prototype.$sarveLandFront = ir('https://core.terminalads.com/#/login');
Vue.prototype.$sarveLand = ir(process.env.VUE_APP_CoreLandUrl);
Vue.prototype.$aiGenerator = ir('https://core-ai.terminalads.com');
Vue.prototype.$shortLink = ir('https://core-link.terminalads.com');

Vue.prototype.$terminal = ir('.terminalads.com');
Vue.prototype.$coreApi3 = ir('https://api.terminalads.com');
Vue.prototype.$coreApi2 = ir('https://api.terminalads.com/api');
Vue.prototype.$coreApi = ir('https://core.terminalads.com');
Vue.prototype.$qrApi = ir('https://qr-api.terminalads.com/api');
Vue.prototype.$mediaApi = ir('https://media.terminalads.com');
Vue.prototype.$linkApi = ir('https://link.terminalads.com');
Vue.prototype.$robotApi = ir('https://robot-api.terminalads.com/api');
Vue.prototype.$payamakApi = ir('https://sms-api.terminalads.com/api');
Vue.prototype.$payamakApi2 = ir('https://sms-api.terminalads.com/api/');
Vue.prototype.$coreLogin = ir('https://core.terminalads.com/#/login');
Vue.prototype.$fileApi = ir('https://file-api.terminalads.com/api');
Vue.prototype.$fileApi2 = ir('https://file-api.terminalads.com/api/');
Vue.prototype.$corepayamakApi = ir('https://core-sms.terminalads.com');
Vue.prototype.$terminalads = ir('https://terminalads.com');
Vue.prototype.$coreqrOrigin = ir('core-qr.terminalads.com');
Vue.prototype.$robotCoreApi = ir('https://core-robot.terminalads.com');
Vue.prototype.$coreqrApi = ir('https://core-qr.terminalads.com');
Vue.prototype.$digiApi = ir('https://core-digi.terminalads.com');
Vue.prototype.$panelrobot = ir('https://core_panel.terminalads.com');

Vue.prototype.$assets = {
  logo: ir('https://api.terminalads.com/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png'),
};

let id_token = localStorage.getItem('id_token');
export const Axios2 = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 15000,
  headers: {
    Authorization: id_token,
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});

const extra = Axios2.get('/user/more').then(res => {
  return {
    announcement: res.data.data.advertises,
    numbers: res.data.data.numbers,
  };
});

const dashboardConfig = {
  announcement: {
    img: '/advertisement-billboard-6097659-5013090.webp',
    text: 'آگهی ثبت شده',
    url: router.resolve({ name: 'myAdsList' }).href,
  },
  numbers: {
    img: '/pngtree-3d-cooperation-businessman-transfer-money-by-phone-icon-png-image_2751467.webp',
    text: 'شماره ها',
    url: router.resolve({ name: 'numberList' }).href,
  },
  counter: extra,
};

let static_top_menu = [];

Vue.use(TerminalTitleRibbon, {
  store,
  axios: Axios2,
  config: () => ({
    dashboardConfig,
    static_top_menu,
    header_logo: require('@/assets/img/rblandNotext.webp'),
  }),
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('id_token'),
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
  permissions: () => store.state.ability,
  core_url: Vue.prototype.$coreApi3,
  front_url: Vue.prototype.$coreApi,
  sid: 4,
});

Vue.prototype.can = value => {
  const abilities = store.state.ability;

  return abilities.indexOf(value + ':active') >= 0 || abilities.indexOf(value + ':show') >= 0;
};

Vue.mixin({
  methods: {
    toggleNavigation() {
      this.$store.dispatch('menu/toggle');
    },
    toggleMobileMenu() {
      this.$store.dispatch('menu/toggle');
      // this.$store.dispatch('menu/toggleMobile');
    },

    persian(input) {
      if (input === undefined || input == null) return '';
      let str1 = input.toString().trim();
      if (str1 === '') return '';
      str1 = str1.replace(/0/gim, '۰');
      str1 = str1.replace(/1/gim, '۱');
      str1 = str1.replace(/2/gim, '۲');
      str1 = str1.replace(/3/gim, '۳');
      str1 = str1.replace(/4/gim, '۴');
      str1 = str1.replace(/5/gim, '۵');
      str1 = str1.replace(/6/gim, '۶');
      str1 = str1.replace(/7/gim, '۷');
      str1 = str1.replace(/8/gim, '۸');
      str1 = str1.replace(/9/gim, '۹');
      return str1;
    },
    english(input) {
      if (input === undefined || input == null) return '';
      let str1 = input.toString().trim();
      if (str1 === '') return '';
      str1 = str1.replace(/۰/gim, '0');
      str1 = str1.replace(/۱/gim, '1');
      str1 = str1.replace(/۲/gim, '2');
      str1 = str1.replace(/۳/gim, '3');
      str1 = str1.replace(/۴/gim, '4');
      str1 = str1.replace(/۵/gim, '5');
      str1 = str1.replace(/۶/gim, '6');
      str1 = str1.replace(/۷/gim, '7');
      str1 = str1.replace(/۸/gim, '8');
      str1 = str1.replace(/۹/gim, '9');
      return str1;
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      } catch (e) {
        return input;
      }
    },
    nowDateTimeString(sp = '-', type = 'datetime') {
      let moment = require('moment-jalaali');
      let res = '';
      if (type === 'date') {
        res = moment().format(`YYYY${sp}MM${sp}DD`);
      } else if (type === 'time') {
        res = moment().format(`HH:mm:ss`);
      } else {
        res = moment().format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
      }
      return res;
    },
    datetime(input, type) {
      if (input == null || input.length === 0) return '-';

      if (type === 'datetime') {
        return `${this.jalalian(input)} ${this.getTime(input)}`;
      } else {
        return `${this.jalalian(input)}`;
      }
    },
    jalalian: function (input) {
      try {
        let moment = require('moment-jalaali');
        let date = moment(input, 'YYYY/MM/DD');
        return date.format('jYYYY/jM/jD');
      } catch (e) {
        return input;
      }
    },
    getTime: function (input) {
      try {
        let time = input.split(' ')[1].split(':');
        return time[0] + ':' + time[1];
      } catch (e) {
        return input;
      }
    },
  },
  computed: {
    ...mapState(['user', 'divar']),
    wallet() {
      return this.$store.getters['wallet/wallet'];
    },
  },
});
Vue.config.productionTip = false;

// start filters
Vue.filter('currency', x => {
  return x ? new Intl.NumberFormat('en-US', { style: 'decimal' }).format(x) : '-';
});

Vue.filter('timeAgo', value => moment(value).fromNow());

Vue.filter('longDate', value => moment(value).format('HH:mm jYYYY-jM-jD'));

Vue.filter('rial', value => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

Vue.filter('stringDate', function (input) {
  try {
    // let moment = require('moment-jalaali')
    moment.locale('fa', null);
    moment.loadPersian({ dialect: 'persian-modern' });
    return moment(input, 'YYYY-M-D HH:mm:ss').format('dddd LL HH:mm:ss');
  } catch (e) {}
});

Vue.filter('persianNum', function (input) {
  try {
    if (input === undefined || input == null) return '';
    let str1 = input.toString().trim();
    if (str1 === '') return '';
    str1 = str1.replace(/0/gim, '۰');
    str1 = str1.replace(/1/gim, '۱');
    str1 = str1.replace(/2/gim, '۲');
    str1 = str1.replace(/3/gim, '۳');
    str1 = str1.replace(/4/gim, '۴');
    str1 = str1.replace(/5/gim, '۵');
    str1 = str1.replace(/6/gim, '۶');
    str1 = str1.replace(/7/gim, '۷');
    str1 = str1.replace(/8/gim, '۸');
    str1 = str1.replace(/9/gim, '۹');
    return str1;
  } catch (e) {}
});

Vue.filter('userType', value => {
  if (value === 'legal') return 'شخص حقوقی';
  return 'شخص حقیقی';
});

Vue.filter('isEmpty', val => {
  return val ? val : '';
});

Vue.filter('serviceType', val => {
  if (val === 'Payamakland') return 'پیامک لند';
  else if (val === 'Coreland') return 'کورلند';
  else if (val === 'Qrland') return 'کیوآر لند';
  else if (val === 'Robotland') return 'ربات لند';
  else if (val === 'billboard') return 'بیلبورد';
  else if (val === 'tablighNegar') return 'تبلیغ نگار';
  else return 'نامعلوم';
});

Vue.filter('persianNumber', value => {
  return value.toPersianLetter();
});

Vue.filter('numericPersianNumber', value => {
  if (value < 1_000_000) return value / 1_000 + ' هزار';
  return value / 1_000_000 + ' میلیون';
});
// end filters

window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
window.url = ir(process.env.VUE_APP_URL);
window.VuePersianDatetimePicker = VuePersianDatetimePicker;

export let dataTableProps = {
  tableProps: {
    search: '',
    length: 10,
    column: 'id',
    dir: 'desc',
    page: 1,
  },
  pagination: {
    align: 'right',
    limit: 4,
  },
  translate: {
    nextButton: 'بعدی',
    previousButton: 'قبلی',
    rowsPerPageText: 'تعداد در صفحه',
    noDataText: 'داده ای برای نمایش وجود ندارد',
    placeholderSearch: 'جستجو کنید..',
  },
};

// API service init
// ApiService.init();

// Remove this to disable mock API
// MockService.init();
//
// router.beforeEach((to, from, next) => {
//     // Ensure we checked auth before each page load.
//     Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);
//
//     // reset config to initial state
//     store.dispatch(RESET_LAYOUT_CONFIG);
//
//     // Scroll page to top on every route change
//     setTimeout(() => {
//         window.scrollTo(0, 0);
//     }, 100);
// });

Vue.component('customPopup', CustomPopup);
Vue.component('customTabs', CustomTabs);
Vue.component('vueTable', VueTable);
Vue.use(DataTable);
Vue.use(VuePersianDatetimePicker, {
  name: 'date-picker',
  props: {
    autoSubmit: true,
    clearable: true,
  },
});

$("input[name='table-search']").parent().removeClass('offset-md-6').addClass('ms-auto');

export const Bus = new Vue({
  methods: {
    setProp(name, value) {
      this[name] = value;
    },
    getProp(name) {
      return this[name];
    },
  },
});

window.Vue = new Vue({
  router,
  store,
  i18n,
  vuetify,
  VuePersianDatetimePicker,
  render: h => h(App),
  methods: {
    async checkTokenAsync(token) {
      try {
        let res = await axios.get(`${this.$coreApi2}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.status === 200) {
          try {
            let resValid = await axios.get(`${this.$coreApi2}/user/validation`, {
              headers: { Authorization: `Bearer ${token}` },
            });

            if (resValid.status === 200) {
              localStorage.setItem('user_info', JSON.stringify(res.data));
              this.$store.dispatch('setUser', res.data);
            }
          } catch (validError) {
            if (validError.response && validError.response.status === 400) {
              this.$root.$emit('open-address-popup');
            } else if (validError.response && validError.response.status === 401) {
              throw validError;
            }
          }
        }
      } catch (e) {
        if (e.response && e.response.status === 401) {
          this.$store
            .dispatch(LOGOUT)
            .then(() => window.location.replace(`${this.$sarveLandFront}`));
        }
      }
    },
    async fetch() {
      let result = null;

      if (!getToken()) {
        const { origin, hash } = window.location;

        destroyToken(origin, hash.substring(1));
      } else {
        try {
          await this.checkTokenAsync(getToken());
        } catch (err) {
          console.error('Token verification error:', err);
        }

        $.ajax({
          url: url + '/user/abilities',
          async: false,
          fn: this.fetch,
          headers: {
            Authorization: Token,
            ACCEPT: 'application/json',
          },
          success: data => {
            this.permissions();
            this.$store.dispatch('global/isLoaded', true);
            this.$store.state.ability = data.data;
            store.commit('setAbilities', data.data);
            result = data.data;
          },
        });
      }

      return result;
    },
    permissions() {
      Vue.directive('status', (element, binding) => {
        const value = binding.value;
        const abilities = this.$store.state.ability;

        if (abilities.indexOf(value + ':active') < 0 && abilities.indexOf(value + ':show') < 0) {
          $(element).remove();
          return;
        }
        if (abilities.indexOf(value + ':show') > -1) {
          $(element).attr('disabled', true);
        }
      });
    },
    getClock() {
      let clock = null;
      $.ajax({
        url: `${url}/setting/clock`,
        type: 'GET',
        async: false,
        fn: this.getClock,
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        success: val => {
          clock = val.data;
        },
      });

      return clock;
    },
    getSpecialmenu() {
      $.ajax({
        url: `${url}/user/menus`,
        type: 'GET',
        fn: this.getSpecialmenu,
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        success: data => {
          this.$store.dispatch('menu/items', data.data);
        },
      });
    },
    setToken() {
      let url = window.location.href;
      const start = url.indexOf('?');
      const end = url.indexOf('#');
      url = url.substring(start, end);
      let token = url.split('token=')[1];

      if (token) {
        Axios2.defaults.headers['Authorization'] = 'Bearer ' + token;
        window.Token = token;
        saveToken(token);

        return window.history.pushState('dashboard', 'Title', '/' + window.location.hash);
      }
    },
  },
  beforeMount() {
    this.setToken();

    router.beforeResolve(async (to, from, next) => {
      store.getters['global/isLoaded'] || (await this.fetch());

      if (to.meta.permission && !ribbonCan(to.meta.permission)) {
        next({ name: 'dashboard' });
      } else next();
    });
  },
  // mounted() {
  // let url = window.location.href;
  // const start = url.indexOf("?token=") + "?token=".length;
  // const end = url.indexOf("#");
  // let token = url.substring(start, end);
  //
  // if (start > 6)
  //     localStorage.setItem("id_token", token);
  //
  // if (localStorage.getItem("id_token"))
  //     window.Token = localStorage.getItem("id_token");

  // try {
  //     this.permissionRoutes();
  //
  //     if (start > 6)
  //         window.history.pushState('dashboard', 'Title', "/");
  // } catch (e) {
  //     const url = process.env.VUE_APP_LOGIN_URL + "#/login?redirect=" + window.location;
  //
  //     window.location.replace(url);
  // }
  // },
}).$mount('#app');
